import { computed } from "vue";

/**
 * Returns the field's layout classes: `--label-inline` lays the label beside the input (`label-position="inline"`).
 *
 * @param {{labelPosition?: string}} props
 */
export function useTextFieldLayout(props) {
  const layoutClasses = computed(() => {
    return {
      "--label-inline": props.labelPosition === "inline",
    };
  });

  return {
    layoutClasses,
  };
}
